export const location_type_options = [
    { id: 1, title: "City" },
    { id: 2, title: "Highway" },
]

export const location_subtype_options = [
    { id: 1, title: "Mall" },
    { id: 2, title: "Retail Outlet" },
    { id: 3, title: "Dealership" },
    { id: 4, title: "Residential" },
    { id: 5, title: "Hotel" },
    { id: 6, title: "Techparks" },
    { id: 7, title: "Hubs" },
]

export const deal_scope_of_work_options = [
    { id: 1, title: "Charger" },
    { id: 2, title: "SaaS" },
    { id: 3, title: "Infra (EPC)" },
    { id: 4, title: "Land Deal" },
    { id: 5, title: "O&M" },
]
export const COLOR_OPTIONS = [
    { color_code: "#4CAF50", name: "Green" },
    { color_code: "#F44336", name: "Red" },
    { color_code: "#3F51B5", name: "Blue" },
    { color_code: "#FF9800", name: "Orange" },
    { color_code: "#9C27B0", name: "Purple" },
    { color_code: "#00BCD4", name: "Cyan" },
    { color_code: "#607D8B", name: "Gray" },
]

export const Countries = [
    { id: 101, title: "India", currency: "INR" },
    { id: 229, title: "UAE", currency: "AED" },
    { id: 153, title: "Nepal", currency: "NPR" },
    { id: 238, title: "Vietnam", currency: "VND" },
]

export const ZONE_OPTIONS = [
    { id: "North", title: "North" },
    { id: "South", title: "South" },
    { id: "East", title: "East" },
    { id: "West", title: "West" },
    { id: "North-East", title: "North-East" },
    { id: "North-West", title: "North-West" },
    { id: "South-East", title: "South-East" },
    { id: "South-West", title: "South-West" },
    { id: "Central", title: "Central" },
]

export const CALL_TYPE_OPTIONS = [
    { id: "Breakdown", title: "Breakdown" },
    { id: "Preventive Maintenance", title: "Preventive Maintenance" },
    { id: "ECN", title: "ECN" },
    { id: "Commissioning", title: "Commissioning" },
    { id: "Survey", title: "Survey" },
]

export const CHARGER_TYPE_OPTIONS = [
    { id: "AC", title: "AC" },
    { id: "DC", title: "DC" },
]

export const CPO_ASSIGNED_DEPARTMENTS = [{ id: "Network Reliability", title: "Network Reliability" }]
export const COMPLAINTS_STATUSES = [
    { id: "Open", name: "Open" },
    { id: "Attended", name: "Attended" },
    { id: "In Progress", name: "In-Progress" },
    { id: "Resolved", name: "Resolved" },
    { id: "Deferred", name: "Deferred" },
]
export const COMPLAINTS_PRIORITY = [
    { id: "Critical", title: "Critical" },
    { id: "High", title: "High" },
    { id: "Medium", title: "Medium" },
    { id: "Low", title: "Low" },
]

export const ASSIGNED_DEPARTMENTS = [
    { id: "Hardware Service", title: "Hardware Service" },
    { id: "Operations", title: "Operations" },
    { id: "Business", title: "Business" },
]
export const OUTRIGHT_ASSIGNED_DEPARTMENTS = [
    { id: "Sales", title: "Sales" },
    { id: "Operations", title: "Operations" },
    { id: "Customer Support", title: "Customer Support" },
    { id: "Hardware Service", title: "Hardware Service" },
]

export const MSME_REG_TYPE_OPTIONS = [
    { id: "Small", title: "Small" },
    { id: "Medium", title: "Medium" },
    { id: "Micro", title: "Micro" },
]

export const GST_TREATMENT_OPTIONS = [
    { id: "Registered Business- Regular", title: "Registered Business- Regular" },
    { id: "Registered Business- Composition", title: "Registered Business- Composition" },
    { id: "Unregistered", title: "Unregistered" },
    { id: "Overseas", title: "Overseas" },
    { id: "Special Economic Zone", title: "Special Economic Zone" },
    { id: "Deemed Export", title: "Deemed Export" },
    { id: "Tax Deductor", title: "Tax Deductor" },
    { id: "SEZ Developer", title: "SEZ Developer" },
]

export const BUDGET_CATEGORIES = [
    {
        id: "Charger",
        title: "Charger",
    },
    {
        id: "Raw material",
        title: "Raw material",
    },
    {
        id: "Contractor Cost",
        title: "Contractor Cost",
    },
    {
        id: "Travel",
        title: "Travel",
    },
    {
        id: "Others",
        title: "Others",
    },
]

export const EXPENSE_CATEGORY = [
    { id: "Travel", title: "Travel" },
    { id: "Food", title: "Food" },
    { id: "Other", title: "Other" },
    { id: "Loadging", title: "Lodging" },
]

export const WARRANT_STATUS = [
    { id: 1, title: "In Warranty" },
    { id: 2, title: "Out Warranty" },
]

export const ECOM_DOWNLOAD_STATUS = [
    { id: 42, title: "Dispatched" },
    { id: 174, title: "Out for Delivery" },
    { id: 176, title: "Order Returned" },
    { id: 175, title: "Order Not Delivered" },
    { id: 43, title: "Delivered" },
]

export const VEHICLE_MODELS = [
    { id: "EV6 PE", title: "EV6 PE" },
    { id: "Kia EV9", title: "Kia EV9" },
    { id: "Clavis EV", title: "Clavis EV" },
]
